import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LanguageIcon } from '../../icons';
import JobStatusBadge from './JobStatusBadge';
import { formatDateTime } from '../../utils/transcriptionMeta';
import { getLanguageLabel } from '../../utils/languages';
import { getTranscriptStatusLabel, TRANSCRIPT_STATUS } from '../../utils/transcriptCertification';

const LanguageVersionTabs = ({ versions = [], currentId, className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const detailBase = location.pathname.startsWith('/admin/')
    ? '/admin/transcriptions'
    : '/transcriptions';

  if (!versions || versions.length <= 1) return null;

  return (
    <div className={`md-card mb-4 ${className}`.trim()}>
      <div className="px-5 py-4 border-b border-matdash-border">
        <div className="flex items-center gap-2">
          <div className="md-icon-well bg-matdash-primary-subtle text-matdash-primary">
            <LanguageIcon className="h-5 w-5" />
          </div>
          <h3 className="text-sm font-semibold text-matdash-dark mb-0">Language versions</h3>
        </div>
      </div>
      <div className="md-card-body pt-4">
        <div className="flex flex-wrap gap-2">
          {versions.map((version) => {
            const versionId = version.id;
            const isActive = String(versionId) === String(currentId);
            const label = getLanguageLabel(version.language);
            const dateLabel = version.created_at ? formatDateTime(version.created_at) : '';

            return (
              <button
                key={versionId}
                type="button"
                onClick={() => {
                  if (!isActive) navigate(`${detailBase}/${versionId}`);
                }}
                className={`flex flex-col items-start px-3 py-2 rounded-md-lg border text-left transition-colors min-w-[140px] ${
                  isActive ? 'md-lang-tab-active' : 'md-lang-tab'
                }`}
              >
                <span className="text-sm font-medium text-matdash-dark">{label}</span>
                {dateLabel && (
                  <span className="text-xs text-matdash-muted mt-0.5">{dateLabel}</span>
                )}
                <span className="mt-1 flex flex-wrap gap-1">
                  {version.transcript_status === TRANSCRIPT_STATUS.CERTIFIED || version.is_certified ? (
                    <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium border bg-emerald-50 text-emerald-800 border-emerald-200">
                      {getTranscriptStatusLabel(TRANSCRIPT_STATUS.CERTIFIED)}
                    </span>
                  ) : (
                    <JobStatusBadge status={version.status} className="text-xs" showIcon={false} />
                  )}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LanguageVersionTabs;
